import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types';
const themeSetting = {
    theme: Theme.Generic,
    rankConfig: { sublevelFormat: 'roman', sublevelImages: true },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'flush',
    brand: 'casino.com',
    brandTitle: 'Casino',
    canonicalUrl: 'https://casino.com',
    cdnBase: 'https://cdn.gmcdn.org',
    cdnBaseFallbacks: ['https://flush.gmcdn.org'],
    cdnTiles: 'https://tiles.flush.com',
    cdnBanners: 'https://images.flush.com/',
    discordLink: 'https://discord.gg/NMsaxDF3Yu',
    googleAnalytics: 'G-PP80PE9SH9',
    googleClientId: '1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    // googleClientId: '789939130685-qapegigbhg77v6ngmahi8ulp6vpkpn44.apps.googleusercontent.com',
    googleTagManager: 'GTM-KK6X2SQT',
    languageDefault: 'en',
    languages: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
    languagesTiles: ['ja', 'ko'],
    languagesAutoAccept: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
    intercomId: 'me2zqgio',
    racesEnabled: false,
    supportEmail: 'support@flush.com',
    telegramLink: 'https://t.me/',
    xLink: 'https://x.com/',
    noIndex: false,
    themePath: 'casino',
    verbiageLabel: 'casino',
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'default',
            useMenuItemIndicator: true
        },
        accordion: {
            accordionStyle: 'default'
        },
        auth: {
            useSolidAccentOAuthButton: false,
            showWalletConnect: false,
            useTightModalBodyPadding: false,
            useOffsetModalCloseButton: true
        },
        background: {
            backgroundStyle: 'solid'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'default'
        },
        cardSwiper: {
            cardSwiperStyle: 'default',
            viewAllAsButton: false,
            showNavigationArrows: true,
            disableEdgeMask: false
        },
        button: {
            buttonStyle: 'solid',
            useUppercaseAsDefault: true
        },
        betby: {
            betslipBottom: 60,
            customUI: false
        },
        betfeed: {
            betfeedStyle: 'default',
            usedVerbiage: 'bet_feed',
            enableWeeklyRaceTab: true
        },
        cashier: {
            useAcceptDeclineBonusType: true,
            withdrawOnlyUsdt: false,
            withdrawOnlyUsdtMemeCoins: true,
            useInfoStateForWarnings: true,
            showConversionRateDeposit: false,
            showProgressBarBonusMoney: true,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 500,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: true,
            showImageOnDepositBonusOffers: false,
            depositBonusVerbiage: 'casino_bonus',
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'live_casino', percentage: 10 },
                { category: 'originals', percentage: 5 },
                { category: 'table_games', percentage: 10 }
            ],
            showWithdrawalWarningIfNoFunds: false,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'default',
            useCashierHomeScreen: false,
            useSidetabs: true,
            buyCryptoEnabled: true,
            useCashierV4: true,
            useCompactDepositAddressOptionLayout: false,
            extendCashierVerbiageKeysWithBrandLabel: true,
            useVerificationStep: false
        },
        casinoLobby: {
            casinoLobbyStyle: 'default',
            showLiveWins: false
        },
        chat: {
            chatStyle: 'default',
            requiredLanguageVerbiage: 'english'
        },
        checkbox: {
            useAlternativeTick: false,
            checkboxStyle: 'default'
        },
        dropdown: {
            dropdownStyle: 'default',
            useDropdownBackgroundImage: false
        },
        emailVerify: {
            emailVerifyStyle: 'default'
        },
        footer: {
            footerStyle: 'default',
            useEmbeddedShellDecor: false
        },
        games: {
            showRacesLeaderboard: true,
            showNavigationOnMobile: true,
            showLikeButton: true,
            showLogoWhenPlayingDesktop: true,
            showGameInfoModalOnGamePathMobile: true,
            applyPedestalIllustrationHueShift: true,
            useCompactRacesLeaderboardInfoBackdrop: true,
            showRacesLeaderboardPerimeterIllustrations: false
        },
        header: {
            headerStyle: 'default',
            buttonLoginVariant: 'tertiary',
            useTightRewardsToggleHorizontalPadding: false
        },
        helpdesk: {
            useDynamicBonusTerms: false
        },
        home: {
            homeStyle: 'alternative',
            showBuyCryptoBanner: true,
            showLiveWins: true,
            cryptoBannerStyle: 'default',
            buyCryptoBannerArtStyle: 'framed-chips',
            useAlternateOriginalsCategoryTitle: true,
            showAdventCalendarPage: false
        },
        icons: {
            vipHeaderGlyphDarkFill: false,
            statusIconsUseWarmPalette: false,
            expandSectionToggleUsesMintAccent: false,
            navIconPickerAllowRemoteAssets: true,
            navIconPickerUseBundledIconFactories: false
        },
        infoCard: {
            infoCardStyle: 'solid'
        },
        input: {
            inputStyle: 'default'
        },
        layout: {
            layoutStyle: 'default',
            isContrastTextColor: false,
            useCompactVerticalPagePadding: true,
            useReducedMarginsInHomePage: true,
            useCurrentColorSidebar: false,
            useReferralIconAnimated: true,
            useNewIcons: false,
            useRemoteIcons: false,
            showCryptoPriceDropdown: false,
            showNotInCatalogGames: false,
            showUpdownGameDropdown: false,
            useV2LiveWins: false,
            useReferralBannerOnlyImageCustom: false,
            usePromoItemContentCustom: false,
            useCentralButtonOnMobileMenu: false,
            selectedCentralButton: 'rewards',
            centralButtonDepositThresholdUsd: 20,
            sectionIconSize: 24,
            useExpandedRankPresentation: true,
            useAlternateMobileSidebarBackdrop: false,
            embedWebSiteOrganizationJsonLd: false
        },
        liveWins: {
            liveWinsStyle: 'default',
            usedVerbiage: 'big_wins',
            useSpecialWinCards: true
        },
        loading: {
            useLottie: true,
            publicInitPageLoadDisplayFor: 0,
            playerInitPageLoadDisplayFor: 3000
        },
        maintenance: {
            maintenanceStyle: 'default',
            contentSource: 'hardcoded'
        },
        geoblock: {
            contentSource: 'hardcoded'
        },
        modal: {
            modalStyle: 'flat'
        },
        walletDropdown: {
            showBalancePreferenceToggles: true
        },
        notifications: {
            notificationsStyle: 'default',
            useBorderedPlayerNotificationsIcon: true,
            useGradientPublicNotificationsIcon: true,
            useExtendedDepositNotificationTitles: false
        },
        toasts: {
            toastsStyle: 'default',
            isLocalIcon: false
        },
        tooltip: {
            tooltipStyle: 'default'
        },
        profileModal: {
            profileModalStyle: 'default',
            showFavouriteSection: true,
            useStarsBackgroundOnFavouriteToken: false,
            useTokenArtBackgroundOnDesktop: true,
            useCompactFavouriteTokenMobileCard: true
        },
        promotions: {
            showExpiredPromotions: true,
            useAspectRatioBoxDetailCustom: false,
            promoBannerStyle: 'default',
            promotionsStyle: 'default',
            showActionButton: true,
            highlightTitleFirstWord: false
        },
        provider: {
            providerStyle: 'default',
            useSolidPrimaryGameCountBadge: true
        },
        referral: {
            referralDashboardBannerType: 'html',
            showContainerInFAQ: true,
            faqTitleStyle: 'badge',
            faqVisibilityPreset: 'all',
            accordionGlassStyle: false,
            rulesCardsStyle: 'illustrated',
            rulesFootnoteMuted: false,
            highlightStepTitles: false,
            rankProgressPalette: 'cool',
            usePrefixedVerbiageKeys: true,
            shareModalStyle: 'rich',
            shareMessageVariant: 'campaign',
            shareBannerStyle: 'classic',
            referralDashboardBannerStyle: 'classic'
        },
        transparency: {
            enabled: true
        },
        affiliates: {
            enabled: false,
            usePrefixedVerbiageKeys: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'default',
            useComfortableRewardsTimerLabels: false,
            showSeasonalRewardsCampaignTabs: false
        },
        seoText: {
            style: 'default'
        },
        settings: {
            settingsStyle: 'default'
        },
        sidebar: {
            sidebarStyle: 'alternative',
            showLuckyDip: false,
            showBanner: false
        },
        table: {
            tableStyle: 'default'
        },
        tabs: {
            tabsStyle: 'default',
            useCompactTabStripRadius: false,
            tabButtonsDefaultVariant: 'secondary'
        },
        text: {
            successTextUsesWarmTone: false
        },
        toggle: {
            toggleStyle: 'default'
        },
        topSection: {
            casinoTopSectionStyle: 'default',
            highlightTitleFirstWord: false
        },
        transactions: {
            transactionsStyle: 'default',
            useSegmentedTabs: false,
            useElevatedRows: false,
            showEmptyStateIllustration: false
        },
        vip: {
            vipDashboardStyle: 'default',
            vipAboutStyle: 'default',
            useMarkdownFaqs: true,
            heroCardOpacity: 0.9,
            rewardsTableLayout: 'detailed',
            rewardsProgressPalette: 'cool',
            includeWageringRequirementRow: false,
            reorderPrimaryBenefitCards: false,
            testimonialsHeaderStyle: 'badge',
            useCompactTestimonialsCardHeight: false,
            faqListLength: 'full',
            usePrefixedVerbiageKeys: true,
            assetSet: 'classic',
            negativeBadgeTone: 'coral',
            showRankPrefixBeforeDisplayName: false,
            useAccentPendingTotalsBadge: true,
            useBorderOnMiniVipCalendarCard: true,
            useCompactClubOverviewSectionHeights: true,
            useCompactRoyaltyBannerTypography: true,
            useExpandedRoyaltyBannerSectionSpacing: true,
            useGradientVipCalendarDateHeader: true,
            useTallerRoyaltyBannerOnNarrowScreens: true,
            showRoyaltyBannerInDashboard: false,
            calendarSummaryLabel: 'claimed',
            includeRaceInRakebackBreakdown: false,
            showVipRewardTooltips: false,
            monthlyRewardsTooltipStyle: 'compact',
            useClassicVipCalendarCardChrome: false,
            rakeboostProgressTone: 'accent'
        },
        profileDropdown: {
            showSupport: false,
            profileDropdownStyle: 'default'
        },
        activeEventTheme: {
            eventID: 'christmas2025',
            eventStartDate: '2025-11-21T00:00:00Z',
            eventEndDate: '2025-12-31T23:59:59Z',
            config: {
                pageBackground: false,
                buttonAddon: true,
                navbarBackground: true,
                sidebarBackground: true,
                divider: true,
                customLogo: true
            }
        }
    }
};
const flushCanonicalHelpcenterHref = `${themeSetting.canonicalUrl}/helpcenter`;
const themeSettings = [
    {
        ...themeSetting,
        brand: 'gamma.flush.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        fingerprintjsHost: 'fp.flush.com',
        languages: [
            'ar',
            'cs',
            'de',
            'en',
            'es',
            'fr',
            'id',
            'it',
            'ja',
            'ko',
            'ms',
            'pt',
            'ru',
            'tr',
            'vi',
            'zh'
        ],
        languagesTiles: ['ja', 'ko', 'tr'],
        betbyEnabled: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush.com',
        brand: 'next.flush.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush.casino',
        brand: 'flush.casino',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush1001.com',
        brand: 'flush1001.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush1002.com',
        brand: 'flush1002.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush.meme',
        brand: 'flush.meme',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flushmeme.com',
        brand: 'flushmeme.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'alpha-flush.previewenv.net',
        languages: [
            'ar',
            'cs',
            'de',
            'en',
            'es',
            'fr',
            'id',
            'it',
            'ja',
            'ko',
            'ms',
            'pt',
            'ru',
            'tr',
            'vi',
            'zh'
        ],
        languagesTiles: ['ja', 'ko', 'tr'],
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'localhost',
        languages: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
        noIndex: true
    }
];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getThemeSetting = (domain, fullDomain) => {
    return themeSettings.find((s) => fullDomain.includes(s.brand)) ?? themeSetting;
};
export const endpointSettings = [];
// todo: read alt endpoints from S3, get player endpoints from authentication
export const endpointSetting = (appMode, domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain) => {
    switch (fullDomain) {
        case 'gamma.flush.com':
        case 'preview.flush.com':
        case 'next.flush.com':
            return {
                name: 'casino',
                theme: Theme.Generic,
                betbyBrandId: '2511187282057371656',
                betbyEnabled: true,
                betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
                base: 'monopoly-flush.prod.infinitro.dev',
                baseCurrency: 'USD',
                baseCurrencySymbol: '$',
                baseCurrencyDigits: 2,
                realm: 'prod-flush',
                catalogFilter: CatalogFilter.ReleaseGames,
                endpointType: EndpointType.Production,
                reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
            };
        case 'stable.flush.com':
            return {
                name: 'casino',
                theme: Theme.Generic,
                betbyBrandId: '2511187282057371656',
                betbyEnabled: true,
                betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
                base: 'monopoly-flush.prod.infinitro.dev',
                baseCurrency: 'USD',
                baseCurrencySymbol: '$',
                baseCurrencyDigits: 2,
                realm: 'prod-flush',
                catalogFilter: CatalogFilter.ReleaseGames,
                endpointType: EndpointType.Production,
                reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
            };
    }
    switch (appMode) {
        case AppMode.Player:
            return {
                name: 'casino',
                theme: Theme.Generic,
                betbyBrandId: '2511187282057371656',
                betbyEnabled: true,
                betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
                base: 'monopoly-flush.prod.infinitro.dev',
                baseCurrency: 'USD',
                baseCurrencySymbol: '$',
                baseCurrencyDigits: 2,
                realm: 'prod-flush',
                catalogFilter: CatalogFilter.ReleaseGames,
                endpointType: EndpointType.Production,
                reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
            };
    }
    return {
        name: 'casino',
        theme: Theme.Generic,
        betbyBrandId: '2511187282057371656',
        betbyEnabled: true,
        betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
        base: 'fc133b1e-d9fa-4f82-8ea6-ab4b8bd06814.api-access.org',
        baseCurrency: 'USD',
        baseCurrencySymbol: '$',
        baseCurrencyDigits: 2,
        realm: 'prod-flush',
        catalogFilter: CatalogFilter.ReleaseGames,
        endpointType: EndpointType.Production,
        reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
    };
};
export { themeSetting as genericThemeSetting, themeSettings as genericThemeSettings };
